var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76316 6.52632V10.7368C5.76316 11.4635 5.17406 12.0526 4.44737 12.0526V12.0526C3.72068 12.0526 3.13158 11.4635 3.13158 10.7368V3.63157C3.13158 2.17819 4.30978 1 5.76316 1V1C7.21654 1 8.39473 2.1782 8.39473 3.63158V12.0526C8.39473 14.2327 6.62744 16 4.44737 16V16C2.2673 16 0.5 14.2327 0.5 12.0526V6.52632",
    stroke: "#666666",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.7e58ebe566ce1e6b032ee6e5ec4819e6.svg";
export { ForwardRef as ReactComponent };